import React, { useEffect, useRef, useState } from "react";
import "./AgeHeaderAnimation.css";

const TITLES = {
  young: "Welcome, Young Explorer!",
  tween: "Ready for a Challenge?",
  teen: "Welcome to Puzz.li"
};

function getAgeGroup(age) {
  if (!age) return "none";
  if (age <= 7) return "young";
  if (age <= 12) return "tween";
  return "teen";
}


const AgeHeaderAnimation = ({ age, puzzleIndex }) => {
  const [prevGroup, setPrevGroup] = useState(getAgeGroup(age));
  const [transitioning, setTransitioning] = useState(false);
  const [navAnim, setNavAnim] = useState(false);
  const group = getAgeGroup(age);
  const prevPuzzleRef = useRef(puzzleIndex);

  // Age group transition
  useEffect(() => {
    if (group !== prevGroup) {
      setTransitioning(true);
      const timeout = setTimeout(() => {
        setTransitioning(false);
        setPrevGroup(group);
      }, 700);
      return () => clearTimeout(timeout);
    }
  }, [group, prevGroup]);

  // Puzzle navigation animation
  useEffect(() => {
    if (prevPuzzleRef.current !== puzzleIndex) {
      setNavAnim(true);
      const timeout = setTimeout(() => setNavAnim(false), 500);
      prevPuzzleRef.current = puzzleIndex;
      return () => clearTimeout(timeout);
    }
  }, [puzzleIndex]);

  // Render both previous and current group for transition
  return (
    <div className="age-header-bg-wrapper">
      {transitioning && prevGroup !== "none" && (
        <div className={`age-header-animation ${prevGroup} fade-out`}>
          <HeaderContent group={prevGroup} navAnim={false} />
        </div>
      )}
      {group !== "none" && (
        <div className={`age-header-animation ${group} ${transitioning ? "fade-in" : ""} ${navAnim ? "nav-anim" : ""}`}>
          <HeaderContent group={group} navAnim={navAnim} />
        </div>
      )}
    </div>
  );
};

function HeaderContent({ group, navAnim }) {
  if (group === "young") {
    return (
      <>
        <div className={`balls-bg${navAnim ? " balls-bounce" : ""}`}>
          {[...Array(7)].map((_, i) => (
            <div key={i} className={`ball ball-${i + 1}`}></div>
          ))}
        </div>
        <h1 className={`age-header-title${navAnim ? " title-pop" : ""}`}>{TITLES.young}</h1>
      </>
    );
  }
  if (group === "tween") {
    return (
      <>
        <div className={`shapes-bg${navAnim ? " shapes-spin" : ""}`}>
          {[...Array(6)].map((_, i) => (
            <div key={i} className={`shape shape-${i + 1}`}></div>
          ))}
        </div>
        <h1 className={`age-header-title${navAnim ? " title-pop" : ""}`}>{TITLES.tween}</h1>
      </>
    );
  }
  if (group === "teen") {
    return (
      <>
        <div className={`gradient-bg${navAnim ? " gradient-flash" : ""}`}></div>
        <h1 className={`age-header-title${navAnim ? " title-pop" : ""}`}>{TITLES.teen}</h1>
      </>
    );
  }
  return null;
}

export default AgeHeaderAnimation;
